import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";

import store from "./store.js";

// Actions
import { refreshUser } from "./actions/authActions";

// Components
import PrivateRoute from "./components/common/PrivateRoute.js";

// Views
import BaseLayout from "./views/Layouts/BaseLayout";
import AuthLayout from "./views/Layouts/AuthLayout";
import LandingPage from "./views/pages/LandingPage";
import PasswordResetView from "views/pages/PasswordResetView.js";
import PrivacyPolicy from "./views/pages/PrivacyPolicy";
import Regulamin from "./views/pages/Regulamin";
import SiteMap from "./views/pages/SiteMap";
import WcagInfo from "views/pages/WcagInfo";

import UseDocumentTitle from "./useDocumentTitle";

const AppSRK = () => {
  useEffect(() => {
    if (localStorage.getItem("token")) {
      store.dispatch(refreshUser());
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <UseDocumentTitle />
        <Routes>
          <Route path="/admin" element={<PrivateRoute />}>
            <Route path="/admin/*" element={<BaseLayout />} />
          </Route>
          <Route path="/auth/*" element={<AuthLayout />} />
          <Route exact path="/" element={<LandingPage />} />
          <Route path="/password_reset/:uid/:token" element={<PasswordResetView />} />
          <Route exact path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route exact path="/regulaminSerwisu" element={<Regulamin />} />
          <Route exact path="/wcag" element={<WcagInfo />} />
          <Route exact path="/mapa-strony" element={<SiteMap />} />
        </Routes>
      </Router>
    </Provider>
  );
};

export default AppSRK;
